<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="con01">
<h2 class="contentsHead">Contents</h2>
<div class="contentsEntry">
<p class="contentsEntryName"><a href="#/icemaidenthe_epi#epi">Epigraph</a></p></div>
<div class="contentsEntry" id="ch_01">
<p class="contentsEntryNumber"><a href="#/icemaidenthe_ch01#ch01">1</a></p>
<p class="contentsEntryName">The shoes startled me. They dangled in midair, at eye…</p></div>
<div class="contentsEntry" id="ch_02">
<p class="contentsEntryNumber"><a href="#/icemaidenthe_ch02#ch02">2</a></p>
<p class="contentsEntryName">I blew into the newsroom in a hurry. My editors…</p>
</div>
<div class="contentsEntry" id="ch_03">
<p class="contentsEntryNumber"><span href="#/icemaidenthe_ch03#ch03" title="Link target outside of Sample">3</span></p>
<p class="contentsEntryName">Hoses snaked through the streets and alarms howled like wounded…</p></div>
<div class="contentsEntry" id="ch_04">
<p class="contentsEntryNumber"><span href="#/icemaidenthe_ch04#ch04" title="Link target outside of Sample">4</span></p>
<p class="contentsEntryName">“How could I have known he’d be watching The History…</p>
</div>
<div class="contentsEntry" id="ch_05">
<p class="contentsEntryNumber"><span href="#/icemaidenthe_ch05#ch05" title="Link target outside of Sample">5</span></p>
<p class="contentsEntryName">Burch and I rendezvoused in mid-beach, at the Fisher monument,…</p></div>
<div class="contentsEntry" id="ch_06">
<p class="contentsEntryNumber"><span href="#/icemaidenthe_ch06#ch06" title="Link target outside of Sample">6</span></p>
<p class="contentsEntryName">“You look like you’ve been shot at and missed,” Stone…</p>
</div>
<div class="contentsEntry" id="ch_07">
<p class="contentsEntryNumber"><span href="#/icemaidenthe_ch07#ch07" title="Link target outside of Sample">7</span></p>
<p class="contentsEntryName">I hit the road again early the next morning. Sunny’s…</p>
</div>
<div class="contentsEntry" id="ch_08">
<p class="contentsEntryNumber"><span href="#/icemaidenthe_ch08#ch08" title="Link target outside of Sample">8</span></p>
<p class="contentsEntryName">I cursed Tyler’s name all the way back to Miami…</p></div>
<div class="contentsEntry" id="ch_09">
<p class="contentsEntryNumber"><span href="#/icemaidenthe_ch09#ch09" title="Link target outside of Sample">9</span></p>
<p class="contentsEntryName">“Can’t blame ’er,” Burch muttered gruffly as I sat at…</p>
</div>
<div class="contentsEntry" id="ch_10">
<p class="contentsEntryNumber"><span href="#/icemaidenthe_ch10#ch10" title="Link target outside of Sample">10</span></p>
<p class="contentsEntryName">“Wait till you see her,” I said, sotto voce, as…</p>
</div>
<div class="contentsEntry" id="ch_11">
<p class="contentsEntryNumber"><span href="#/icemaidenthe_ch11#ch11" title="Link target outside of Sample">11</span></p>
<p class="contentsEntryName">The viewing for Andre Coney was set for 7 to…</p>
</div>
<div class="contentsEntry" id="ch_12">
<p class="contentsEntryNumber"><span href="#/icemaidenthe_ch12#ch12" title="Link target outside of Sample">12</span></p>
<p class="contentsEntryName">I called Burch about Cubby Wells and Parvin Stokes, street…</p>
</div>
<div class="contentsEntry" id="ch_13">
<p class="contentsEntryNumber"><span href="#/icemaidenthe_ch13#ch13" title="Link target outside of Sample">13</span></p>
<p class="contentsEntryName">Shelby Fountain stood in the back of the screened-in garden…</p></div>
<div class="contentsEntry" id="ch_14">
<p class="contentsEntryNumber"><span href="#/icemaidenthe_ch14#ch14" title="Link target outside of Sample">14</span></p>
<p class="contentsEntryName">Lottie sashayed down the hall, a stack of photos in…</p>
</div>
<div class="contentsEntry" id="ch_15">
<p class="contentsEntryNumber"><span href="#/icemaidenthe_ch15#ch15" title="Link target outside of Sample">15</span></p>
<p class="contentsEntryName">I felt numb and powerless when I got home, as…</p>
</div>
<div class="contentsEntry" id="ch_16">
<p class="contentsEntryNumber"><span href="#/icemaidenthe_ch16#ch16" title="Link target outside of Sample">16</span></p>
<p class="contentsEntryName">I called Burch from a cubicle in the public information…</p>
</div>
<div class="contentsEntry" id="ch_17">
<p class="contentsEntryNumber"><span href="#/icemaidenthe_ch17#ch17" title="Link target outside of Sample">17</span></p>
<p class="contentsEntryName">It was the worst kind, according to our research in…</p>
</div>
<div class="contentsEntry" id="ch_18">
<p class="contentsEntryNumber"><span href="#/icemaidenthe_ch18#ch18" title="Link target outside of Sample">18</span></p>
<p class="contentsEntryName">I found him at an inner-city church where clothes are…</p>
</div>
<div class="contentsEntry" id="ch_19">
<p class="contentsEntryNumber"><span href="#/icemaidenthe_ch19#ch19" title="Link target outside of Sample">19</span></p>
<p class="contentsEntryName">Too much champagne, I thought, my visions of disaster now…</p></div>
<div class="contentsEntry" id="ch_20">
<p class="contentsEntryNumber"><span href="#/icemaidenthe_ch20#ch20" title="Link target outside of Sample">20</span></p>
<p class="contentsEntryName">“Where’s Sunny?” I gasped.</p></div>
<div class="contentsEntry" id="ch_21">
<p class="contentsEntryNumber"><span href="#/icemaidenthe_ch21#ch21" title="Link target outside of Sample">21</span></p>
<p class="contentsEntryName">“Relax,” Burch told me when I called his office at…</p>
</div>
<div class="contentsEntry" id="ch_22">
<p class="contentsEntryNumber"><span href="#/icemaidenthe_ch22#ch22" title="Link target outside of Sample">22</span></p>
<p class="contentsEntryName">“Sunny? You scared me. What are you doing up there?”</p>
</div>
<div class="contentsEntry" id="ch_23">
<p class="contentsEntryNumber"><span href="#/icemaidenthe_ch23#ch23" title="Link target outside of Sample">23</span></p>
<p class="contentsEntryName">The telephone line was dead and Sunny had no cell…</p>
</div>
<div class="contentsEntry" id="ch_24">
<p class="contentsEntryNumber"><span href="#/icemaidenthe_ch24#ch24" title="Link target outside of Sample">24</span></p>
<p class="contentsEntryName">They say you have begun to heal when it’s not…</p>
</div>
<div class="contentsEntry" id="bm_01">
<p class="contentsEntryName"><span href="#/icemaidenthe_bm01#bm01" title="Link target outside of Sample">Acknowledgments</span></p>
</div>
<div class="contentsEntry" id="ata_01">
<p class="contentsEntryName"><span href="#/icemaidenthe_ata01#ata01" title="Link target outside of Sample">About the Author</span></p>
</div>
<div class="contentsEntry" id="bm_02">
<p class="contentsEntryName"><span href="#/icemaidenthe_bm02#bm02" title="Link target outside of Sample">Praise</span></p>
</div>
<div class="contentsEntry" id="bm_03">
<p class="contentsEntryName"><span href="#/icemaidenthe_bm03#bm03" title="Link target outside of Sample">Other Books by Edna Buchanan</span></p>
</div>
<div class="contentsEntry" id="cop_01">
<p class="contentsEntryName"><span href="#/icemaidenthe_cop01#cop01" title="Link target outside of Sample">Copyright</span></p>
</div>
<div class="contentsEntry" id="atp_01">
<p class="contentsEntryName"><span href="#/icemaidenthe_atp01#atp01" title="Link target outside of Sample">About the Publisher</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// icemaidenthe_con01.vue?5a631146